'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.action = exports.query = exports.section = undefined;

require('isomorphic-fetch');

require('isomorphic-form-data');

require('./origin.polyfill');

var _section = require('./section');

var _section2 = _interopRequireDefault(_section);

var _query = require('./query');

var _query2 = _interopRequireDefault(_query);

var _action = require('./action');

var _action2 = _interopRequireDefault(_action);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.section = _section2.default;
exports.query = _query2.default;
exports.action = _action2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/index.js
// module id = 258
// module chunks = 0